import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMinus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgMinus);
const Memo = memo(ForwardRef);
export default Memo;
